module.exports = __webpack_public_path__ + "static/img/10.b22e3c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/sp/10.png
// module id = qi+2
// module chunks = 0